import { gql } from '@lcs/shared/api';

export const saveDashboardTileLayoutConfigurations = gql`
   mutation SaveDashboardTileLayoutConfigurations(
      $dashboardTileLayoutConfigurations: [DashboardTileLayoutConfigurationInput!]!
      $dashboard: DashboardInput!
   ) {
      saveDashboardTileLayoutConfigurations(dashboardTileLayoutConfigurations: $dashboardTileLayoutConfigurations) {
         dashboardTileId
         dashboardTile {
            tileViewMode
         }
         dashboardTileLayoutConfigurationId
         color
         height
         width
         refreshTimeSeconds
         maxHeight
         minHeight
         maxWidth
         minWidth
         name
         column
         row
      }
      saveDashboard(dashboard: $dashboard) {
         dashboardId
         lastSavedColumnLayoutSize
      }
   }
`;
